import Flex from '@components/Flex/Flex';
import { styled } from '@mui/material';

export const StyledContainer = styled(Flex)(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[500]}`,
  padding: theme.spacing(17, 11),
  borderRadius: theme.spacing(5),
  alignItems: 'center',
  flex: 1,
}));
